module.exports = __webpack_public_path__ + "static/media/28_A.68fcef98.png";